/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class PostShareButton extends React.Component {
    constructor(props) {
        super(props);

        this.postMethod = this.postMethod.bind(this);

    }

    postMethod() {

        if (this.props.postMethod) {
            this.props.postMethod(this.props.itemId);
        }

    }

    render() {
        return (
            <span>
                <div className="item-share curate-item-share item-share-full">
                    <div className="btn-item-share" onClick={this.postMethod} data-itemid={this.props.itemId} role="button" aria-label='share'>
                        <span>Share</span>
                        <i className="fa fa-share fa-lg"></i>
                    </div>
                </div>
                <div className="item-share curate-item-share item-share-compact">
                    <span className="fa-stack fa-lg">
                        <i className="fa fa-square-o fa-stack-2x"></i>
                        <i className="fa fa-share fa-stack-1x"></i>
                    </span>
                </div>
            </span>
        );
    }

};

PostShareButton.propTypes = {
    itemId: PropTypes.string,
    repostMethod: PropTypes.func
};

PostShareButton.defaultProps = {
    itemId: null,
    postMethod: null
};

export default PostShareButton;
